import './mines-result-panel.scss';

import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import {
  minesActions,
  selectMinesGame,
  selectMinesResult,
  selectMinesStatus,
} from '@/entities/mines';
import { type CurrencyCode, formatCurrencyValue } from '@/shared/lib/currency';

export function MinesResultPanel() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const status = useAppSelector(selectMinesStatus);
  const game = useAppSelector(selectMinesGame);
  const result = useAppSelector(selectMinesResult);

  if (!result) return null;

  const currency = (game?.currency as CurrencyCode) ?? 'TON';
  const isWon = status === 'won';

  return (
    <div className={`mines-result${isWon ? ' mines-result--won' : ' mines-result--busted'}`}>
      <div className="mines-result__glow" />

      <div className="mines-result__content">
        <span className="mines-result__badge">
          {isWon ? '💎' : '💣'}
        </span>

        <p className="mines-result__title">{isWon ? t('mines.cashedOut') : t('mines.busted')}</p>

        <p className="mines-result__payout">
          {isWon ? '+' : '-'}
          {formatCurrencyValue(isWon ? result.payout : (game?.betAmount ?? 0), currency)}
        </p>

        {isWon && (
          <p className="mines-result__mult">{result.multiplier.toFixed(2)}×</p>
        )}
      </div>

      <button
        className="mines-result__again"
        onClick={() => dispatch(minesActions.resetGame())}>
        {t('mines.playAgain')}
      </button>
    </div>
  );
}
